export const ENVIRONMENT = process.env.NODE_ENV || "dev";

export const TARGET_URL =
  process.env.NEXT_PUBLIC_TARGET_URL || "https://www.tataaig.com";
export const API_BASE =
  process.env.NEXT_PUBLIC_API_BASE || "http://localhost:3000";
export const API_BASE_SUPERAPP =
  process.env.NEXT_PUBLIC_API_BASE_SUPERAPP ||
  "https://renewalvault.tataaig.com/superapp";
export const GOOGLE_ANALYTICS_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_KEY || "UA-91406081-6";
export const GOOGLE_MEASURMENT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID || "G-2ZMREXC604";
export const IMAGE_BASE_PATH = "/servicing/renewal-health";
export const IPDS_REDIRECT_PATH =
  "https://sellonline.tataaig.com/ipdsv2/health/medicare/#/renewal/previewReviewProposal/";
export const IPDS_REDIRECT_TW_AND_PC_PATH =
  "https://www.tataaig.com/lambda/prod-motorRenewal/generateRenewalLink";
export const IPDS_LOGIN_PATH =
  "https://sellonline.tataaig.com/ipdsv2/login/#/login";
  export const GLOBALUID_GENERATOR =
  process.env.NEXT_PUBLIC_GLOBALUID_GENERATOR ||
  "https://test10bn.tataaig.com/lambda/test-genericService/generateGlobalUid";
export const WEBSITE_URL =
  process.env.NEXT_PUBLIC_WEBSITE_TARGET_URL ||
  "https://www.tataaig.com/lambda/prod-genericService";
export const BOLT_REDIRECTION =
  process.env.NEXT_PUBLIC_BOLT_REDIRECTION ||
  "https://dev10bn.tataaig.com/retail-health";
export const BOLT_SALT =
  process.env.NEXT_PUBLIC_BOLT_SALT || "o6aaqycnw0dd1111";
export const TATA_API_BASE_URL =
  process.env.NEXT_PUBLIC_TATA_API_BASE_URL || "https://uatappapi.tataaig.com";
export const TATA_API_KEY =
  process.env.NEXT_PUBLIC_TATA_API_KEY ||
  "d48bec27-f4f3-4a74-80cc-1361ed599ca7";
export const URL_STORE = {
  moengage: {
    moengageScriptInJS: "/servicing/renewal-health/moengage.js",
  },
};
